/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useState } from "react";
import { Html, useGLTF } from "@react-three/drei";
import { animated, useSpring } from "@react-spring/three";

export default function Model({ angle, ...props }) {
  const group = useRef();
  const { nodes } = useGLTF(
    "/house.glb",
    "https://www.gstatic.com/draco/versioned/decoders/1.4.1/"
  );
  let [hover, setHover] = useState(null);
  let [clicked, setClicked] = useState(null);
  let { opacity } = useSpring({ opacity: angle !== 0 ? 1 : 0 });
  let { opacity2 } = useSpring({ opacity2: angle !== 1 ? 1 : 0 });
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        onClick={(e) => {
          e.stopPropagation();
          setClicked(null);
        }}
        onPointerEnter={(e) => {
          e.stopPropagation();
        }}
        geometry={nodes.Cube.geometry}
        material={nodes.Cube.material}
        position={[0.470225632191, 0.278645128012, 0.404163241386]}
      />
      <mesh
        onPointerEnter={() => {
          setClicked(null);
          setHover(3);
        }}
        onPointerLeave={() => {
          setHover(null);
        }}
        onClick={(e) => {
          e.stopPropagation();
          setClicked(3);
          setHover(null);
        }}
        geometry={nodes["00_audo"].geometry}
        material={nodes["00_audo"].material}
        position={[1.597102046013, 0.043766390532, -1.66673374176]}
      >
        <meshStandardMaterial
          {...nodes["00_audo"].material}
          color={
            hover === 3 || clicked === 3
              ? "red"
              : nodes["00_audo"].material.color
          }
        ></meshStandardMaterial>
        {(hover === 3 || clicked === 3) && (
          <Html style={{ pointerEvents: "none" }}>
            <div className="popup">
              <div className="head">
                <div className="fakeText head"></div>
              </div>

              <div className="statusWrapper">
                <div className="status">
                  <div className="dot"></div>
                  <div className="fakeText"></div>
                </div>
              </div>
            </div>
          </Html>
        )}
      </mesh>
      <mesh
        geometry={nodes["00_Hausecke_B"].geometry}
        material={nodes["00_Hausecke_B"].material}
        position={[-0.736651480198, 0.632346332073, 0.824060201645]}
      >
        <animated.meshStandardMaterial
          {...nodes["00_Hausecke_B"].material}
          tranlucent
          transparent
          opacity={opacity2}
        ></animated.meshStandardMaterial>
      </mesh>

      <mesh
        geometry={nodes["00_Hausecke_A"].geometry}
        material={nodes["00_Hausecke_A"].material}
        position={[-0.626153886318, 0.694583952427, -0.846620202065]}
      >
        <animated.meshStandardMaterial
          {...nodes["00_Hausecke_A"].material}
          tranlucent
          transparent
          opacity={opacity}
        ></animated.meshStandardMaterial>
      </mesh>
      <mesh
        onPointerEnter={() => {
          setClicked(null);
          setHover(1);
        }}
        onPointerLeave={() => {
          setHover(null);
        }}
        onClick={(e) => {
          e.stopPropagation();
          setClicked(1);
          setHover(null);
        }}
        geometry={nodes["00_Objekt_A"].geometry}
        material={nodes["00_Objekt_A"].material}
        position={[-0.581628859043, 0.154590308666, -0.123631730676]}
      >
        <meshStandardMaterial
          {...nodes["00_Objekt_A"].material}
          color={
            hover === 1 || clicked === 1
              ? "red"
              : nodes["00_Objekt_A"].material.color
          }
        ></meshStandardMaterial>
        {(hover === 1 || clicked === 1) && angle === 0 && (
          <Html style={{ pointerEvents: "none" }}>
            <div className="popup">
              <div className="head">
                <div className="fakeText head"></div>
              </div>

              <div className="statusWrapper">
                <div className="status">
                  <div className="dot"></div>
                  <div className="fakeText"></div>
                </div>
              </div>
            </div>
          </Html>
        )}
      </mesh>
      <mesh
        onPointerEnter={() => {
          setClicked(null);
          setHover(2);
        }}
        onPointerLeave={() => {
          setHover(null);
        }}
        onClick={(e) => {
          e.stopPropagation();
          setClicked(2);
          setHover(null);
        }}
        geometry={nodes["00_0bjekt_B"].geometry}
        material={nodes["00_0bjekt_B"].material}
        position={[-0.022674098611, 0.137403309345, 0.727478206158]}
      >
        <meshStandardMaterial
          {...nodes["00_0bjekt_B"].material}
          color={
            hover === 2 || clicked === 2
              ? "red"
              : nodes["00_0bjekt_B"].material.color
          }
        ></meshStandardMaterial>
        {(hover === 2 || clicked === 2) && angle === 1 && (
          <Html style={{ pointerEvents: "none" }}>
            <div className="popup">
              <div className="head">
                <div className="fakeText head"></div>
              </div>

              <div className="statusWrapper">
                <div className="status">
                  <div className="dot"></div>
                  <div className="fakeText"></div>
                </div>
              </div>
            </div>
          </Html>
        )}
      </mesh>
      <mesh
        onPointerEnter={(e) => {
          e.stopPropagation();
        }}
        geometry={nodes["00_Boden_A"].geometry}
        material={nodes["00_Boden_A"].material}
        position={[0, 0.024755403399, -0.740990579128]}
      />
      <mesh
        onPointerEnter={(e) => {
          e.stopPropagation();
        }}
        geometry={nodes["00_Boden_B"].geometry}
        material={nodes["00_Boden_B"].material}
        position={[0, 0.024755403399, 0.740991234779]}
      />
    </group>
  );
}

useGLTF.preload(
  "/house.glb",
  "https://www.gstatic.com/draco/versioned/decoders/1.4.1/"
);
